<template>
    <v-dialog v-model="obModal.abrirModal" :max-width="tamModal" :scrollable="$root.isTouch == false"
        :fullscreen="$root.isTouch" persistent>
        <v-card elevation="11">
            <v-card-title class="bg-title-card">
                <span class="white--text headline" v-html="obModal.titulo"></span>
            </v-card-title>
            <v-card-text>
                <v-form ref="form_beneficio" :lazy-validation="false">
                    <v-container fluid grid-list-sm>
                        <v-row dense>
                            <v-col cols="12">
                                <div class="text-center" v-if="_.size(base64) > 0">
                                    <img :src="base64" height="140px" />
                                </div>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                    <v-dialog ref="dialogFechaDesdeModal" v-model="objDate.desde.abrirModal"
                                          :return-value.sync="obModal.fechaVigenciaIni" persistent width="340px">
                                          <template v-slot:activator="{ on }">
                                                <v-text-field color="textbox" v-model="obModal.fechaVigenciaIni"
                                                      label="Fecha Desde *" prepend-inner-icon="event" readonly outlined
                                                      dense v-on="on" :rules="requeridoRegla" />
                                          </template>
                                          <v-date-picker color="primary" v-model="obModal.fechaVigenciaIni" scrollable
                                                locale="es">
                                                <v-spacer></v-spacer>
                                                <v-btn outlined dense rounded color="danger"
                                                      @click="objDate.desde.abrirModal = false" v-html="'Salir'">
                                                </v-btn>
                                                <v-btn rounded dark color="primary"
                                                      @click="$refs.dialogFechaDesdeModal.save(obModal.fechaVigenciaIni)"
                                                      v-html="'Guardar Fecha'"></v-btn>
                                          </v-date-picker>
                                    </v-dialog>
                              </v-col>
                              <v-col cols="12" sm="6">
                                    <v-dialog ref="dialogFechaHastaModal" v-model="objDate.hasta.abrirModal"
                                          :return-value.sync="obModal.fechaVigenciaFin" persistent width="340px">
                                          <template v-slot:activator="{ on }">
                                                <v-text-field color="textbox" v-model="obModal.fechaVigenciaFin"
                                                      label="Fecha Hasta *" prepend-inner-icon="event" readonly outlined
                                                      dense v-on="on" :rules="requeridoRegla" />
                                          </template>
                                          <v-date-picker color="primary" v-model="obModal.fechaVigenciaFin" scrollable
                                                locale="es">
                                                <v-spacer></v-spacer>
                                                <v-btn outlined dense rounded color="danger"
                                                      @click="objDate.hasta.abrirModal = false" v-html="'Salir'">
                                                </v-btn>
                                                <v-btn rounded dark color="primary"
                                                      @click="$refs.dialogFechaHastaModal.save(obModal.fechaVigenciaFin)"
                                                      v-html="'Guardar Fecha'"></v-btn>
                                          </v-date-picker>
                                    </v-dialog>
                              </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-row dense>
                                    <v-col cols="12" sm="6">
                                        <v-autocomplete label="Proveedor *" color="textbox"
                                            v-model="obModal.idProveedor" :items="listGeneral.listProveedor"
                                            item-value="idProveedor" item-text="proveedor" :rules="requeridoRegla"
                                            outlined dense />
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-autocomplete label="Tipo de Servicio *" color="textbox"
                                            :rules="requeridoRegla" v-model="obModal.idTipoServicioComp"
                                            :items="_.filter(listGeneral.listTipoServicio,(v)=>{ return !_.isNull(v.value) })" outlined dense />
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="12">
                                        <v-text-field label="Beneficio *" color="textbox"
                                            v-model="obModal.nombreServicioComp"
                                            :rules="_.concat(requeridoRegla,max300Regla)" outlined dense />
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="6">
                                        <v-file-input label="Seleccionar Icono *" v-model="obModal.icono" outlined dense
                                            prepend-icon="add_a_photo" :rules="_.size(base64) == 0 ? requeridoRegla : []" @change="lodaFile"
                                            accept="image/png,image/jpg,image/jpej" color="textbox"/>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-autocomplete label="Estado *" color="textbox" v-model="obModal.idEstado"
                                            :items="_.filter(_.get(listGeneral,'listEstado',[]),{'visualiza':'true'})"
                                            item-value="id_estado" item-text="nombre_estado" outlined dense
                                            :rules="requeridoRegla" />
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="12">
                                        <v-textarea filled label="Beneficio Público *" :value="obModal.nombreServicioCompPresentacion" 
                                                    v-model="obModal.nombreServicioCompPresentacion" dense color="textbox"
                                                    :rules="_.concat(requeridoRegla,max500Regla)"></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="text-right">
                                <v-btn outlined rounded color="danger" class="mr-1" @click="cerrar" v-html="'Cancelar'" :disabled="disabled" />
                                <v-btn rounded dark color="primary" @click="guardar" v-html="'Guardar'" :disabled="disabled" />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'ModalServicioComplementarioComponent',
        inject: ['insertarActualizar','reset'],
        props: {
            listGeneral: {
                type: Object,
                default: {}
            },
            obBeneficioModal: {
                type: Object,
                default: {}
            },
            load: {
                type: Boolean,
                default: false
            },
            icono:{
                type:String,
                default:''
            }
        },
        data: () => ({
            objDate: {
                        desde: { abrirModal: false },
                        hasta: { abrirModal: false },
                    },
            obModal: {
                abrirModal: false,
                titulo: '',
                fechaVigenciaIni: moment().format('YYYY-MM-DD'),
                fechaVigenciaFin: moment().format('YYYY-MM-DD'),
            },
            disabled: false,
            base64:null
        }),
        watch: {
            load(val) {
                if(val){
                    this.$set(this,'obModal',_.merge(this.obModal,this.obBeneficioModal));
                    if (!_.isNull(_.get(this,'icono', null))) 
                        this.base64 = _.cloneDeep(`data:image/png;base64,${this.icono}`);
                    
                    if (!_.isUndefined(this.$refs.form_beneficio))
                        this.$refs.form_beneficio.resetValidation();
                }
            }
        },
        methods: {
            lodaFile(){
                this.disabled = true;
                var reader = new FileReader();
                    reader.readAsDataURL(this.obModal.icono);
                    reader.onload = () => {
                        this.$set(this,'base64',reader.result);
                        this.$forceUpdate();
                        this.disabled = false;
                    };
            },
            guardar() {
                try {
                    this.disabled = true;
                    if (!this.$refs.form_beneficio.validate()) throw mensajeEstandar.corregirInformacion;
                    if (_.size(this.base64) == 0) throw mensajeEstandar.corregirInformacion;                        
                        var keys = [
                                        'opcion','idTipoServicioComp','idProveedor','nombreServicioComp','idServiciosComp',
                                        'nombreServicioCompPresentacion','fechaVigenciaIni','fechaVigenciaFin','idEstado'
                                    ];

                        this.insertarActualizar(_.merge({},_.pick(this.obModal,keys),{icono: this.base64}))
                            .then((r)=>{
                                if(!r) throw 'Error';
                                    this.cerrar();
                            })
                            .catch((e)=>{
                                this.disabled = false;
                            });
                } catch (error) {
                    mensajesAlerta(error, 'I');
                    this.disabled = false;
                }
            },
            cerrar(){
                this.base64 = null;
                this.obModal= { abrirModal: false, titulo: '' };
                this.disabled = false;
                this.reset({},false);
            }

        }

    }
</script>